import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, viewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CatalogItemService } from 'src/app/services/catalog-item.service';
import { GetCatalogItem } from 'src/app/models/catalogs/catalog';
import { Paged } from 'src/app/models/shared/paged';
import { PaginationComponent } from '../../pagination/pagination.component';
import { ModalCatalogWizardComponent } from './modal-catalog-wizard/modal-catalog-wizard.component';
import { ModalCatalogVersionsComponent } from './modal-catalog-versions/modal-catalog-versions.component';
import { LoadingService } from 'src/app/services/loading.service';
import Swal from 'sweetalert2';
import { finalize } from 'rxjs';
import { ModalDuplicateCatalogVersionComponent } from './modal-duplicate-catalog-version/modal-duplicate-catalog-version.component';

@Component({
  selector: 'app-catalog-items',
  standalone: true,
  imports: [CommonModule, FormsModule, PaginationComponent, ModalCatalogWizardComponent,
    ModalCatalogVersionsComponent, ModalDuplicateCatalogVersionComponent
  ],
  templateUrl: './catalog-items.component.html',
  styleUrl: './catalog-items.component.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CatalogItemsComponent {
  private catalogSvc = inject(CatalogItemService);
  loadingSvc = inject(LoadingService);

  filter: any = {
    page: 1,
    pageSize: 10,
    filterKey: '',
    filterValue: ''
  };

  showFilters = false;
  isLoading = false;
  totalItems = 0;

  items: GetCatalogItem[] = [];

  public modalCatalogWizardComponent = viewChild(ModalCatalogWizardComponent);
  public modalCatalogVersionsComponent = viewChild(ModalCatalogVersionsComponent);
  public modalDuplicateCatalogVersionComponent = viewChild(ModalDuplicateCatalogVersionComponent);

  ngOnInit() {
    this.load();
  }

  load() {
    this.isLoading = true;
    this.catalogSvc.getCatalogItems(this.filter).subscribe({
      next: (res: Paged<GetCatalogItem>) => {
        this.items = res.items || [];
        this.totalItems = res.totalItems || 0;
        this.isLoading = false;
      },
      error: (error) => {
        Swal.fire('Error', error[0] ?? 'Error al obtener los datos', 'error');
        this.items = [];
        this.totalItems = 0;
        this.isLoading = false;
      }
    });
  }

  onSearch() {
    this.filter.page = 1;
    this.load();
  }

  showFilter() {
    this.showFilters = !this.showFilters;
  }

  onPageChange(page: number) {
    this.filter.page = page;
    this.load();
  }

  onPageSizeChange(size: number) {
    this.filter.pageSize = size;
    this.filter.page = 1;
    this.load();
  }

  viewVersions(header: GetCatalogItem) {
    const modal = this.modalCatalogVersionsComponent();
    if (modal) {
      modal.open(header);
    }
  }

  deleteItem(itemId: number) {
    Swal.fire({
      title: '¿Eliminar este ítem del catálogo?',
      text: 'Esta acción no se puede deshacer.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then(result => {
      if (result.isConfirmed) {
        this.loadingSvc.show();
        this.catalogSvc.deleteCatalogItem(itemId)
          .pipe(
            finalize(() => this.loadingSvc.hide())
          )
          .subscribe({
            next: () => {
              Swal.fire({
                icon: "success",
                title: "Ítem eliminado exitosamente!",
                showConfirmButton: true,
                timer: 2000
              });
              this.items = this.items.filter(item => item.id != itemId);
              this.totalItems -= this.totalItems;
            },
            error: error => {
              Swal.fire({
                icon: "error",
                title: "Error al eliminar el ítem",
                showConfirmButton: true,
                text: error[0] ?? "Inténtalo de nuevo.",
              });
            }
          });
      }
    });
  }

  openAddItemModal() {
    const modalCatalogWizardComponent = this.modalCatalogWizardComponent();
    if (modalCatalogWizardComponent) {
      modalCatalogWizardComponent.resetWizardData();
      modalCatalogWizardComponent.getOptions();
      const modal = new (window as any).bootstrap.Modal('#modalCatalogWizard', {});
      modal.show();
    }
  }

  openDuplicateModal(item: GetCatalogItem) {
    const modal = this.modalDuplicateCatalogVersionComponent();
    if (modal) {
      modal.open(item.id, item.publishedVersionId ?? 0);
    }
  }

}